import React, { useMemo, useState, Fragment } from 'react';
import { TrendingUp, Clock, BarChart3, Wallet, CreditCard, Plus, AlertCircle, ArrowDownToLine, Search, Filter, ChevronDown, ChevronUp, Download, X, CheckCircle2, FileText, ArrowUpRight, ArrowDownRight, RefreshCcw, Percent, Crown, Megaphone, Receipt, PiggyBank, ArrowRight } from 'lucide-react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { Badge } from '../ui/Badge';
import { Input } from '../ui/Input';
interface FinancesTabProps {
  showToast: (msg: string) => void;
  setActiveTab?: (tab: string) => void;
}
type TxType = 'income' | 'withdrawal' | 'refund' | 'commission' | 'subscription' | 'advertising';
type TxStatus = 'completed' | 'pending' | 'failed';
interface Transaction {
  id: string;
  date: string;
  type: TxType;
  description: string;
  amount: number;
  status: TxStatus;
  orderId?: string;
  clientName?: string;
  serviceName?: string;
  commissionPercent?: number;
  commissionAmount?: number;
  netAmount?: number;
  source?: string;
}
interface PaymentMethod {
  id: string;
  type: 'card' | 'crypto' | 'paypal';
  name: string;
  details: string;
  isDefault: boolean;
}
const MOCK_TRANSACTIONS: Transaction[] = [{
  id: 'tx-sub-3',
  date: '2024-10-15T00:01:00',
  type: 'subscription',
  description: 'Подписка PRO — Октябрь',
  amount: -990,
  status: 'completed',
  source: 'balance'
}, {
  id: 'tx-ad-2',
  date: '2024-10-14T18:00:00',
  type: 'advertising',
  description: 'Реклама: Баннер в каталоге',
  amount: -1500,
  status: 'completed',
  source: 'balance'
}, {
  id: 'tx-1042',
  date: '2024-10-15T14:30:00',
  type: 'income',
  description: 'Оплата заказа #1042',
  amount: 5000,
  status: 'completed',
  orderId: 'ORD-1042',
  clientName: 'Елена Смирнова',
  serviceName: 'Натальная карта',
  commissionPercent: 15,
  commissionAmount: 750,
  netAmount: 4250
}, {
  id: 'tx-1041',
  date: '2024-10-14T11:15:00',
  type: 'income',
  description: 'Оплата заказа #1041',
  amount: 6000,
  status: 'completed',
  orderId: 'ORD-1041',
  clientName: 'Дмитрий В.',
  serviceName: 'Синастрия',
  commissionPercent: 15,
  commissionAmount: 900,
  netAmount: 5100
}, {
  id: 'tx-w1',
  date: '2024-10-10T09:00:00',
  type: 'withdrawal',
  description: 'Вывод средств на карту *4276',
  amount: -32000,
  status: 'completed',
  commissionPercent: 0,
  commissionAmount: 0,
  netAmount: -32000
}, {
  id: 'tx-ad-1',
  date: '2024-10-05T12:00:00',
  type: 'advertising',
  description: 'Реклама: Закрепление в категории',
  amount: -2000,
  status: 'completed',
  source: 'balance'
}, {
  id: 'tx-sub-2',
  date: '2024-09-15T00:01:00',
  type: 'subscription',
  description: 'Подписка PRO — Сентябрь',
  amount: -990,
  status: 'completed',
  source: 'card'
}, {
  id: 'tx-1030',
  date: '2024-10-01T16:45:00',
  type: 'income',
  description: 'Оплата заказа #1030',
  amount: 5000,
  status: 'completed',
  orderId: 'ORD-1030',
  clientName: 'Анна К.',
  serviceName: 'Натальная карта',
  commissionPercent: 15,
  commissionAmount: 750,
  netAmount: 4250
}, {
  id: 'tx-1029',
  date: '2024-09-28T20:10:00',
  type: 'income',
  description: 'Покупка товара',
  amount: 990,
  status: 'completed',
  orderId: 'ORD-1029',
  clientName: 'Иван П.',
  serviceName: 'Вебинар Меркурий',
  commissionPercent: 10,
  commissionAmount: 99,
  netAmount: 891
}, {
  id: 'tx-r1',
  date: '2024-09-20T12:00:00',
  type: 'refund',
  description: 'Возврат по заказу #1020',
  amount: -5000,
  status: 'completed',
  orderId: 'ORD-1020',
  clientName: 'Мария Л.',
  serviceName: 'Натальная карта'
}, {
  id: 'tx-w2',
  date: '2024-09-15T10:30:00',
  type: 'withdrawal',
  description: 'Вывод средств на карту *4276',
  amount: -28500,
  status: 'completed',
  commissionPercent: 0,
  commissionAmount: 0,
  netAmount: -28500
}, {
  id: 'tx-1015',
  date: '2024-09-10T15:20:00',
  type: 'income',
  description: 'Оплата заказа #1015',
  amount: 15000,
  status: 'completed',
  orderId: 'ORD-1015',
  clientName: 'Ольга В.',
  serviceName: 'Соляр на год',
  commissionPercent: 15,
  commissionAmount: 2250,
  netAmount: 12750
}, {
  id: 'tx-1043',
  date: '2024-10-16T08:00:00',
  type: 'income',
  description: 'Оплата заказа #1043',
  amount: 4500,
  status: 'pending',
  orderId: 'ORD-1043',
  clientName: 'Сергей М.',
  serviceName: 'Экспресс-консультация',
  commissionPercent: 15,
  commissionAmount: 675,
  netAmount: 3825
}, {
  id: 'tx-1044',
  date: '2024-10-16T09:30:00',
  type: 'income',
  description: 'Оплата заказа #1044',
  amount: 4500,
  status: 'pending',
  orderId: 'ORD-1044',
  clientName: 'Алина Т.',
  serviceName: 'Экспресс-консультация',
  commissionPercent: 15,
  commissionAmount: 675,
  netAmount: 3825
}];
const MOCK_METHODS: PaymentMethod[] = [{
  id: 'pm-1',
  type: 'card',
  name: 'Сбербанк',
  details: 'Visa •••• 4276',
  isDefault: true
}];
const SERVICES_INCOME = [{
  name: 'Натальная карта',
  amount: 210000,
  percent: 100,
  color: 'bg-indigo-500'
}, {
  name: 'Соляр на год',
  amount: 112000,
  percent: 53,
  color: 'bg-indigo-400'
}, {
  name: 'Синастрия',
  amount: 90000,
  percent: 43,
  color: 'bg-indigo-300'
}, {
  name: 'Товары',
  amount: 44550,
  percent: 21,
  color: 'bg-indigo-200'
}];
export function FinancesTab({
  showToast,
  setActiveTab
}: FinancesTabProps) {
  // State
  const [transactions, setTransactions] = useState<Transaction[]>(MOCK_TRANSACTIONS);
  const [methods, setMethods] = useState<PaymentMethod[]>(MOCK_METHODS);
  // Modals & Forms
  const [showWithdrawModal, setShowWithdrawModal] = useState(false);
  const [withdrawAmount, setWithdrawAmount] = useState('');
  const [selectedMethodId, setSelectedMethodId] = useState(MOCK_METHODS[0].id);
  const [addingCard, setAddingCard] = useState(false);
  const [newCard, setNewCard] = useState({
    number: '',
    name: ''
  });
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const [downloadPeriod, setDownloadPeriod] = useState('month');
  const [downloadType, setDownloadType] = useState('all');
  // Filters & UI State
  const [searchQuery, setSearchQuery] = useState('');
  const [showFilters, setShowFilters] = useState(false);
  const [filterType, setFilterType] = useState<TxType | 'all'>('all');
  const [filterStatus, setFilterStatus] = useState<TxStatus | 'all'>('all');
  const [expandedTxId, setExpandedTxId] = useState<string | null>(null);
  // Unified Balance
  const mainBalance = 24500;
  const pendingAmount = 9000;
  const totalBalance = mainBalance + pendingAmount;
  const earnedThisMonth = 48000;
  const totalEarned = 324500;
  // Expenses
  const subscriptionExpense = 990;
  const advertisingExpense = 3500;
  const commissionExpense = 5325;
  const totalExpenses = subscriptionExpense + advertisingExpense + commissionExpense;
  // Ad budget
  const adBudgetBalance = 4500;
  // Derived Data
  const availableToWithdraw = 24500;
  const filteredTransactions = useMemo(() => {
    return transactions.filter(tx => {
      const matchesSearch = tx.description.toLowerCase().includes(searchQuery.toLowerCase()) || tx.orderId && tx.orderId.toLowerCase().includes(searchQuery.toLowerCase()) || tx.clientName && tx.clientName.toLowerCase().includes(searchQuery.toLowerCase());
      const matchesType = filterType === 'all' || tx.type === filterType;
      const matchesStatus = filterStatus === 'all' || tx.status === filterStatus;
      return matchesSearch && matchesType && matchesStatus;
    }).sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
  }, [transactions, searchQuery, filterType, filterStatus]);
  // Handlers
  const handleWithdraw = () => {
    const amount = parseInt(withdrawAmount.replace(/\D/g, ''), 10);
    if (isNaN(amount) || amount < 1000) {
      showToast('Минимальная сумма вывода: 1 000 ₽');
      return;
    }
    if (amount > availableToWithdraw) {
      showToast('Недостаточно средств для вывода');
      return;
    }
    const newTx: Transaction = {
      id: `tx-w-${Date.now()}`,
      date: new Date().toISOString(),
      type: 'withdrawal',
      description: `Вывод средств на ${methods.find(m => m.id === selectedMethodId)?.details}`,
      amount: -amount,
      status: 'pending',
      commissionPercent: 0,
      commissionAmount: 0,
      netAmount: -amount
    };
    setTransactions([newTx, ...transactions]);
    setShowWithdrawModal(false);
    setWithdrawAmount('');
    showToast('Заявка на вывод успешно создана');
    console.log(`[Admin Sync] Withdrawal requested: ${amount} RUB to ${selectedMethodId}`);
  };
  const handleAddCard = () => {
    if (!newCard.number || !newCard.name) {
      showToast('Заполните все поля');
      return;
    }
    const method: PaymentMethod = {
      id: `pm-${Date.now()}`,
      type: 'card',
      name: 'Новая карта',
      details: `Visa •••• ${newCard.number.slice(-4)}`,
      isDefault: false
    };
    setMethods([...methods, method]);
    setAddingCard(false);
    setNewCard({
      number: '',
      name: ''
    });
    showToast('Карта успешно добавлена');
    console.log(`[Admin Sync] New payment method added: ${method.id}`);
  };
  const handleDownload = () => {
    setShowDownloadModal(false);
    showToast('Файл выписки формируется и скоро будет скачан');
    console.log(`[Admin Sync] Statement downloaded: period=${downloadPeriod}, type=${downloadType}`);
  };
  const handleCardClick = (type: TxType | 'all', status: TxStatus | 'all' = 'all') => {
    setFilterType(type);
    setFilterStatus(status);
    setSearchQuery('');
    // Scroll to transactions
    document.getElementById('transactions-section')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  // Formatters
  const formatMoney = (amount: number) => {
    return new Intl.NumberFormat('ru-RU', {
      style: 'currency',
      currency: 'RUB',
      maximumFractionDigits: 0
    }).format(amount);
  };
  const formatDate = (dateStr: string) => {
    return new Intl.DateTimeFormat('ru-RU', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    }).format(new Date(dateStr));
  };
  const getTypeConfig = (type: TxType) => {
    switch (type) {
      case 'income':
        return {
          label: 'Доход',
          color: 'text-emerald-600',
          bg: 'bg-emerald-50',
          icon: <ArrowDownRight className="w-4 h-4" data-id="element-12769" />
        };
      case 'withdrawal':
        return {
          label: 'Вывод',
          color: 'text-slate-900',
          bg: 'bg-slate-100',
          icon: <ArrowUpRight className="w-4 h-4" data-id="element-12770" />
        };
      case 'refund':
        return {
          label: 'Возврат',
          color: 'text-rose-600',
          bg: 'bg-rose-50',
          icon: <RefreshCcw className="w-4 h-4" data-id="element-12771" />
        };
      case 'commission':
        return {
          label: 'Комиссия',
          color: 'text-amber-600',
          bg: 'bg-amber-50',
          icon: <Percent className="w-4 h-4" data-id="element-12772" />
        };
      case 'subscription':
        return {
          label: 'Подписка',
          color: 'text-indigo-600',
          bg: 'bg-indigo-50',
          icon: <Crown className="w-4 h-4" data-id="element-12773" />
        };
      case 'advertising':
        return {
          label: 'Реклама',
          color: 'text-purple-600',
          bg: 'bg-purple-50',
          icon: <Megaphone className="w-4 h-4" data-id="element-12774" />
        };
    }
  };
  const getStatusBadge = (status: TxStatus) => {
    switch (status) {
      case 'completed':
        return <Badge variant="success" size="sm" data-id="element-12775">
            Выполнено
          </Badge>;
      case 'pending':
        return <Badge variant="warning" size="sm" data-id="element-12776">
            В обработке
          </Badge>;
      case 'failed':
        return <Badge variant="error" size="sm" data-id="element-12777">
            Ошибка
          </Badge>;
    }
  };
  return <div className="space-y-6 pb-20 sm:pb-0" data-id="element-12778">
      {/* Header */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-2" data-id="element-12779">
        <div data-id="element-12780">
          <h2 className="text-2xl font-bold text-slate-900" data-id="element-12781">Финансы</h2>
          <p className="text-slate-500 text-sm mt-1" data-id="element-12782">
            Единый баланс · Доходы · Расходы · Выводы
          </p>
        </div>
        <Button variant="outline" icon={<ArrowDownToLine className="w-4 h-4" data-id="element-12784" />} onClick={() => setShowDownloadModal(true)} className="w-full sm:w-auto" data-id="element-12783">
          Скачать выписку
        </Button>
      </div>

      {/* Unified Balance */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4" data-id="element-12785">
        {/* Main Balance Card */}
        <Card padding="md" className="bg-slate-900 text-white border-none flex flex-col justify-between sm:col-span-2 lg:col-span-2 relative overflow-hidden group cursor-pointer" onClick={() => handleCardClick('all', 'completed')} data-id="element-12786">
          <div className="absolute top-0 right-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity" data-id="element-12787">
            <Wallet className="w-24 h-24" data-id="element-12788" />
          </div>
          <div className="relative z-10" data-id="element-12789">
            <div className="text-slate-400 text-sm mb-1 font-medium" data-id="element-12790">
              Общий баланс
            </div>
            <div className="text-4xl font-bold mb-0.5" data-id="element-12791">
              {formatMoney(totalBalance)}
            </div>
            <div className="flex gap-4 text-sm mb-4" data-id="element-12792">
              <span className="text-emerald-400" data-id="element-12793">
                Доступно: {formatMoney(mainBalance)}
              </span>
              <span className="text-amber-400" data-id="element-12794">
                В ожидании: {formatMoney(pendingAmount)}
              </span>
            </div>
            <div className="text-slate-400 text-xs mb-4" data-id="element-12795">
              Используется для вывода, подписки и рекламы
            </div>
          </div>
          <div className="relative z-10" data-id="element-12796">
            <Button variant="primary" fullWidth size="lg" className="bg-indigo-600 hover:bg-indigo-500 text-white border-none shadow-lg shadow-indigo-900/20" onClick={e => {
            e.stopPropagation();
            setShowWithdrawModal(true);
          }} data-id="element-12797">
              Вывести средства
            </Button>
          </div>
        </Card>

        {/* Income this month */}
        <Card padding="md" className="flex flex-col justify-between cursor-pointer hover:border-indigo-300 transition-colors" onClick={() => handleCardClick('income')} data-id="element-12798">
          <div data-id="element-12799">
            <div className="text-slate-500 text-sm mb-1 font-medium" data-id="element-12800">
              Доход за месяц
            </div>
            <div className="text-2xl font-bold text-slate-900 mb-2" data-id="element-12801">
              {formatMoney(earnedThisMonth)}
            </div>
          </div>
          <div className="text-sm text-emerald-600 flex items-center font-medium bg-emerald-50 w-fit px-2 py-1 rounded-md" data-id="element-12802">
            <TrendingUp className="w-4 h-4 mr-1" data-id="element-12803" /> +12% к прошлому
          </div>
        </Card>

        {/* Expenses this month */}
        <Card padding="md" className="flex flex-col justify-between cursor-pointer hover:border-rose-300 transition-colors" onClick={() => {
        setFilterType('all');
        setFilterStatus('all');
        document.getElementById('expenses-section')?.scrollIntoView({
          behavior: 'smooth'
        });
      }} data-id="element-12804">
          <div data-id="element-12805">
            <div className="text-slate-500 text-sm mb-1 font-medium" data-id="element-12806">
              Расходы за месяц
            </div>
            <div className="text-2xl font-bold text-slate-900 mb-2" data-id="element-12807">
              {formatMoney(totalExpenses)}
            </div>
          </div>
          <div className="text-sm text-rose-600 flex items-center font-medium bg-rose-50 w-fit px-2 py-1 rounded-md" data-id="element-12808">
            <Receipt className="w-4 h-4 mr-1" data-id="element-12809" /> Подписка + Реклама
          </div>
        </Card>

        <Card padding="md" className="flex flex-col justify-between cursor-pointer hover:border-indigo-300 transition-colors" onClick={() => handleCardClick('income')} data-id="element-12810">
          <div data-id="element-12811">
            <div className="text-slate-500 text-sm mb-1 font-medium" data-id="element-12812">
              Всего заработано
            </div>
            <div className="text-2xl font-bold text-slate-900 mb-2" data-id="element-12813">
              {formatMoney(totalEarned)}
            </div>
          </div>
          <div className="text-sm text-indigo-600 flex items-center font-medium bg-indigo-50 w-fit px-2 py-1 rounded-md" data-id="element-12814">
            <BarChart3 className="w-4 h-4 mr-1" data-id="element-12815" /> За всё время
          </div>
        </Card>
      </div>

      {/* Expenses Breakdown */}
      <div id="expenses-section" data-id="element-12816">
        <Card padding="md" data-id="element-12817">
          <div className="flex justify-between items-center mb-4" data-id="element-12818">
            <h3 className="font-bold text-slate-900 flex items-center gap-2" data-id="element-12819">
              <Receipt className="w-5 h-5 text-rose-500" data-id="element-12820" /> Расходы за месяц
            </h3>
            <span className="text-sm font-bold text-slate-900" data-id="element-12821">
              {formatMoney(totalExpenses)}
            </span>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-4" data-id="element-12822">
            <div className="p-3 bg-indigo-50 rounded-xl border border-indigo-100 cursor-pointer hover:border-indigo-300 transition-colors" onClick={() => {
            setFilterType('subscription');
            document.getElementById('transactions-section')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} data-id="element-12823">
              <div className="flex items-center gap-2 mb-1" data-id="element-12824">
                <Crown className="w-4 h-4 text-indigo-600" data-id="element-12825" />
                <span className="text-xs font-medium text-indigo-600" data-id="element-12826">
                  Подписка
                </span>
              </div>
              <div className="text-lg font-bold text-slate-900" data-id="element-12827">
                {formatMoney(subscriptionExpense)}
              </div>
              <div className="text-[10px] text-slate-500 mt-0.5" data-id="element-12828">
                PRO · списание с баланса
              </div>
            </div>
            <div className="p-3 bg-purple-50 rounded-xl border border-purple-100 cursor-pointer hover:border-purple-300 transition-colors" onClick={() => {
            setFilterType('advertising');
            document.getElementById('transactions-section')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} data-id="element-12829">
              <div className="flex items-center gap-2 mb-1" data-id="element-12830">
                <Megaphone className="w-4 h-4 text-purple-600" data-id="element-12831" />
                <span className="text-xs font-medium text-purple-600" data-id="element-12832">
                  Реклама
                </span>
              </div>
              <div className="text-lg font-bold text-slate-900" data-id="element-12833">
                {formatMoney(advertisingExpense)}
              </div>
              <div className="text-[10px] text-slate-500 mt-0.5" data-id="element-12834">
                Баланс рекламы: {formatMoney(adBudgetBalance)}
              </div>
            </div>
            <div className="p-3 bg-amber-50 rounded-xl border border-amber-100 cursor-pointer hover:border-amber-300 transition-colors" onClick={() => {
            setFilterType('commission');
            document.getElementById('transactions-section')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} data-id="element-12835">
              <div className="flex items-center gap-2 mb-1" data-id="element-12836">
                <Percent className="w-4 h-4 text-amber-600" data-id="element-12837" />
                <span className="text-xs font-medium text-amber-600" data-id="element-12838">
                  Комиссия платформы
                </span>
              </div>
              <div className="text-lg font-bold text-slate-900" data-id="element-12839">
                {formatMoney(commissionExpense)}
              </div>
              <div className="text-[10px] text-slate-500 mt-0.5" data-id="element-12840">
                15% от заказов
              </div>
            </div>
          </div>
          <div className="bg-slate-50 rounded-lg p-3 border border-slate-100 flex items-center justify-between" data-id="element-12841">
            <div className="text-sm text-slate-600" data-id="element-12842">
              <span className="font-medium text-slate-900" data-id="element-12843">Прозрачность:</span>{' '}
              каждый заказ показывает сумму, комиссию и чистый доход
            </div>
            <ArrowRight className="w-4 h-4 text-slate-400" data-id="element-12844" />
          </div>
        </Card>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-12845">
        {/* Section 2: Способ вывода */}
        <Card padding="md" className="lg:col-span-2" data-id="element-12846">
          <div className="flex justify-between items-center mb-6" data-id="element-12847">
            <h3 className="font-bold text-slate-900 flex items-center gap-2" data-id="element-12848">
              <Wallet className="w-5 h-5 text-indigo-500" data-id="element-12849" /> Способ вывода
              средств
            </h3>
            {!addingCard && <Button variant="ghost" size="sm" icon={<Plus className="w-4 h-4" data-id="element-12851" />} onClick={() => setAddingCard(true)} data-id="element-12850">
                Добавить карту
              </Button>}
          </div>

          {addingCard ? <div className="bg-slate-50 border border-slate-200 rounded-xl p-5 mb-4 animate-in fade-in slide-in-from-top-2" data-id="element-12852">
              <h4 className="text-sm font-bold text-slate-900 mb-4" data-id="element-12853">
                Добавление новой карты
              </h4>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4" data-id="element-12854">
                <Input label="Номер карты" placeholder="0000 0000 0000 0000" value={newCard.number} onChange={e => setNewCard({
              ...newCard,
              number: e.target.value
            })} data-id="element-12855" />
                <Input label="Имя владельца (как на карте)" placeholder="IVAN IVANOV" value={newCard.name} onChange={e => setNewCard({
              ...newCard,
              name: e.target.value
            })} data-id="element-12856" />
              </div>
              <div className="flex gap-3 justify-end" data-id="element-12857">
                <Button variant="outline" onClick={() => setAddingCard(false)} data-id="element-12858">
                  Отмена
                </Button>
                <Button variant="primary" onClick={handleAddCard} data-id="element-12859">
                  Сохранить карту
                </Button>
              </div>
            </div> : <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4" data-id="element-12860">
              {methods.map(method => <div key={method.id} className={`border rounded-xl p-4 cursor-pointer transition-all ${selectedMethodId === method.id ? 'border-indigo-500 bg-indigo-50/30 ring-1 ring-indigo-500' : 'border-slate-200 hover:border-indigo-300 bg-white'}`} onClick={() => setSelectedMethodId(method.id)} data-id="element-12861">
                  <div className="flex items-center justify-between mb-3" data-id="element-12862">
                    <div className="flex items-center gap-3" data-id="element-12863">
                      <div className="w-10 h-10 bg-white rounded-lg shadow-sm flex items-center justify-center border border-slate-100" data-id="element-12864">
                        <CreditCard className="w-5 h-5 text-slate-700" data-id="element-12865" />
                      </div>
                      <div data-id="element-12866">
                        <div className="font-bold text-slate-900" data-id="element-12867">
                          {method.details}
                        </div>
                        <div className="text-xs text-slate-500" data-id="element-12868">
                          {method.name}
                        </div>
                      </div>
                    </div>
                    {method.isDefault && <Badge variant="success" size="sm" data-id="element-12869">
                        Основная
                      </Badge>}
                  </div>
                  <div className="flex justify-end" data-id="element-12870">
                    <Button variant="ghost" size="sm" className="text-slate-400 hover:text-indigo-600 h-8 px-2" onClick={e => {
                e.stopPropagation();
                setAddingCard(true);
                showToast('Заполните данные новой карты');
              }} data-id="element-12871">
                      Изменить
                    </Button>
                  </div>
                </div>)}
            </div>}

          <div className="bg-slate-50 rounded-lg p-4 flex items-start gap-3 border border-slate-100" data-id="element-12872">
            <AlertCircle className="w-5 h-5 text-indigo-500 flex-shrink-0 mt-0.5" data-id="element-12873" />
            <div className="text-sm text-slate-600" data-id="element-12874">
              <p className="font-medium text-slate-900 mb-1" data-id="element-12875">
                Условия вывода средств
              </p>
              <ul className="list-disc list-inside space-y-1 text-slate-500" data-id="element-12876">
                <li data-id="element-12877">
                  Комиссия за вывод:{' '}
                  <strong className="text-slate-700" data-id="element-12878">0%</strong>
                </li>
                <li data-id="element-12879">
                  Срок зачисления:{' '}
                  <strong className="text-slate-700" data-id="element-12880">1-3 рабочих дня</strong>
                </li>
                <li data-id="element-12881">
                  Минимальная сумма вывода:{' '}
                  <strong className="text-slate-700" data-id="element-12882">1 000 ₽</strong>
                </li>
              </ul>
            </div>
          </div>
        </Card>

        {/* Section 3: Доход по услугам */}
        <Card padding="md" data-id="element-12883">
          <h3 className="font-bold text-slate-900 mb-6 flex items-center gap-2" data-id="element-12884">
            <BarChart3 className="w-5 h-5 text-indigo-500" data-id="element-12885" /> Доход по услугам
          </h3>

          <div className="space-y-5" data-id="element-12886">
            {SERVICES_INCOME.map((item, i) => <div key={i} className="group cursor-pointer" onClick={() => {
            if (setActiveTab) setActiveTab('orders');else showToast(`Заказы: ${item.name}`);
          }} data-id="element-12887">
                <div className="flex justify-between text-sm mb-2" data-id="element-12888">
                  <span className="font-medium text-slate-700 group-hover:text-indigo-600 transition-colors" data-id="element-12889">
                    {item.name}
                  </span>
                  <span className="font-bold text-slate-900" data-id="element-12890">
                    {formatMoney(item.amount)}
                  </span>
                </div>
                <div className="w-full bg-slate-100 rounded-full h-2 overflow-hidden" data-id="element-12891">
                  <div className={`h-full rounded-full ${item.color} transition-all duration-500`} style={{
                width: `${item.percent}%`
              }} data-id="element-12892"></div>
                </div>
              </div>)}
          </div>

          <Button variant="outline" fullWidth className="mt-6" onClick={() => {
          if (setActiveTab) setActiveTab('services');else showToast('Переход ко всем услугам');
        }} data-id="element-12893">
            Смотреть все услуги
          </Button>
        </Card>
      </div>

      {/* Section 4: История транзакций */}
      <Card padding="none" className="overflow-hidden" id="transactions-section" data-id="element-12894">
        <div className="p-4 sm:p-6 border-b border-slate-100" data-id="element-12895">
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-4" data-id="element-12896">
            <h3 className="font-bold text-slate-900 text-lg" data-id="element-12897">
              История транзакций
            </h3>

            <div className="flex w-full sm:w-auto gap-2" data-id="element-12898">
              <div className="relative flex-1 sm:w-64" data-id="element-12899">
                <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" data-id="element-12900" />
                <input type="text" placeholder="Поиск по ID или клиенту..." className="w-full pl-9 pr-4 py-2 bg-slate-50 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 transition-all" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-12901" />
              </div>
              <Button variant={showFilters ? 'primary' : 'outline'} icon={<Filter className="w-4 h-4" data-id="element-12903" />} onClick={() => setShowFilters(!showFilters)} className="shrink-0" data-id="element-12902">
                <span className="hidden sm:inline" data-id="element-12904">Фильтры</span>
              </Button>
            </div>
          </div>

          {/* Filters Panel */}
          {showFilters && <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 p-4 bg-slate-50 rounded-xl border border-slate-200 animate-in fade-in slide-in-from-top-2" data-id="element-12905">
              <div data-id="element-12906">
                <label className="block text-xs font-bold text-slate-500 uppercase tracking-wider mb-1.5" data-id="element-12907">
                  Тип операции
                </label>
                <select className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500" value={filterType} onChange={e => setFilterType(e.target.value as TxType | 'all')} data-id="element-12908">
                  <option value="all" data-id="element-12909">Все типы</option>
                  <option value="income" data-id="element-12910">Доход</option>
                  <option value="withdrawal" data-id="element-12911">Вывод средств</option>
                  <option value="subscription" data-id="element-12912">Подписка</option>
                  <option value="advertising" data-id="element-12913">Реклама</option>
                  <option value="refund" data-id="element-12914">Возврат</option>
                  <option value="commission" data-id="element-12915">Комиссия</option>
                </select>
              </div>
              <div data-id="element-12916">
                <label className="block text-xs font-bold text-slate-500 uppercase tracking-wider mb-1.5" data-id="element-12917">
                  Статус
                </label>
                <select className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500" value={filterStatus} onChange={e => setFilterStatus(e.target.value as TxStatus | 'all')} data-id="element-12918">
                  <option value="all" data-id="element-12919">Все статусы</option>
                  <option value="completed" data-id="element-12920">Выполнено</option>
                  <option value="pending" data-id="element-12921">В обработке</option>
                  <option value="failed" data-id="element-12922">Ошибка</option>
                </select>
              </div>
              <div className="flex items-end" data-id="element-12923">
                <Button variant="ghost" fullWidth className="text-slate-500 hover:text-slate-900 bg-white border border-slate-200" onClick={() => {
              setFilterType('all');
              setFilterStatus('all');
              setSearchQuery('');
            }} data-id="element-12924">
                  Сбросить фильтры
                </Button>
              </div>
            </div>}
        </div>

        {/* Desktop Table */}
        <div className="hidden md:block overflow-x-auto" data-id="element-12925">
          <table className="w-full text-left text-sm" data-id="element-12926">
            <thead className="bg-slate-50/50 text-slate-500 border-b border-slate-100" data-id="element-12927">
              <tr data-id="element-12928">
                <th className="px-6 py-4 font-semibold" data-id="element-12929">Дата</th>
                <th className="px-6 py-4 font-semibold" data-id="element-12930">Тип</th>
                <th className="px-6 py-4 font-semibold" data-id="element-12931">Описание</th>
                <th className="px-6 py-4 font-semibold" data-id="element-12932">Статус</th>
                <th className="px-6 py-4 font-semibold text-right" data-id="element-12933">Сумма</th>
                <th className="px-6 py-4 font-semibold w-10" data-id="element-12934"></th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100" data-id="element-12935">
              {filteredTransactions.length > 0 ? filteredTransactions.map(tx => {
              const isExpanded = expandedTxId === tx.id;
              const config = getTypeConfig(tx.type);
              return <Fragment key={tx.id} data-id="element-12936">
                      <tr className={`hover:bg-slate-50/80 transition-colors cursor-pointer ${isExpanded ? 'bg-slate-50/80' : ''}`} onClick={() => setExpandedTxId(isExpanded ? null : tx.id)} data-id="element-12937">
                        <td className="px-6 py-4 text-slate-500 whitespace-nowrap" data-id="element-12938">
                          {formatDate(tx.date)}
                        </td>
                        <td className="px-6 py-4" data-id="element-12939">
                          <div className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-xs font-medium ${config.bg} ${config.color}`} data-id="element-12940">
                            {config.icon}
                            {config.label}
                          </div>
                        </td>
                        <td className="px-6 py-4 text-slate-900 font-medium" data-id="element-12941">
                          {tx.description}
                        </td>
                        <td className="px-6 py-4" data-id="element-12942">
                          {getStatusBadge(tx.status)}
                        </td>
                        <td className={`px-6 py-4 text-right font-bold whitespace-nowrap ${tx.amount > 0 ? 'text-emerald-600' : 'text-slate-900'}`} data-id="element-12943">
                          {tx.amount > 0 ? '+' : ''}
                          {formatMoney(tx.amount)}
                        </td>
                        <td className="px-6 py-4 text-slate-400" data-id="element-12944">
                          {isExpanded ? <ChevronUp className="w-5 h-5" data-id="element-12945" /> : <ChevronDown className="w-5 h-5" data-id="element-12946" />}
                        </td>
                      </tr>

                      {/* Expanded Details Row */}
                      {isExpanded && <tr className="bg-slate-50/50 border-b border-slate-200" data-id="element-12947">
                          <td colSpan={6} className="px-6 py-4" data-id="element-12948">
                            <div className="bg-white border border-slate-200 rounded-xl p-5 shadow-sm animate-in fade-in slide-in-from-top-2" data-id="element-12949">
                              <div className="grid grid-cols-2 md:grid-cols-4 gap-6" data-id="element-12950">
                                <div data-id="element-12951">
                                  <div className="text-xs text-slate-500 uppercase tracking-wider font-bold mb-1" data-id="element-12952">
                                    ID Транзакции
                                  </div>
                                  <div className="text-sm font-medium text-slate-900 font-mono" data-id="element-12953">
                                    {tx.id}
                                  </div>
                                </div>

                                {tx.orderId && <div data-id="element-12954">
                                    <div className="text-xs text-slate-500 uppercase tracking-wider font-bold mb-1" data-id="element-12955">
                                      Заказ
                                    </div>
                                    <div className="text-sm font-medium text-indigo-600 hover:underline cursor-pointer" onClick={e => {
                            e.stopPropagation();
                            if (setActiveTab) setActiveTab('orders');else showToast(`Заказ ${tx.orderId}`);
                          }} data-id="element-12956">
                                      {tx.orderId}
                                    </div>
                                  </div>}

                                {tx.clientName && <div data-id="element-12957">
                                    <div className="text-xs text-slate-500 uppercase tracking-wider font-bold mb-1" data-id="element-12958">
                                      Клиент
                                    </div>
                                    <div className="text-sm font-medium text-slate-900" data-id="element-12959">
                                      {tx.clientName}
                                    </div>
                                  </div>}

                                {tx.serviceName && <div data-id="element-12960">
                                    <div className="text-xs text-slate-500 uppercase tracking-wider font-bold mb-1" data-id="element-12961">
                                      Услуга
                                    </div>
                                    <div className="text-sm font-medium text-slate-900" data-id="element-12962">
                                      {tx.serviceName}
                                    </div>
                                  </div>}
                              </div>

                              {/* Commission Breakdown for Income */}
                              {tx.type === 'income' && tx.commissionAmount !== undefined && tx.netAmount !== undefined && <div className="mt-6 pt-4 border-t border-slate-100" data-id="element-12963">
                                    <div className="text-xs text-slate-500 uppercase tracking-wider font-bold mb-3" data-id="element-12964">
                                      Расчет выплаты
                                    </div>
                                    <div className="flex flex-col sm:flex-row gap-4 sm:gap-8 bg-slate-50 p-4 rounded-lg border border-slate-100" data-id="element-12965">
                                      <div data-id="element-12966">
                                        <div className="text-xs text-slate-500 mb-1" data-id="element-12967">
                                          Сумма заказа
                                        </div>
                                        <div className="font-medium text-slate-900" data-id="element-12968">
                                          {formatMoney(tx.amount)}
                                        </div>
                                      </div>
                                      <div className="hidden sm:flex items-center text-slate-300" data-id="element-12969">
                                        -
                                      </div>
                                      <div data-id="element-12970">
                                        <div className="text-xs text-slate-500 mb-1" data-id="element-12971">
                                          Комиссия платформы (
                                          {tx.commissionPercent}%)
                                        </div>
                                        <div className="font-medium text-rose-600" data-id="element-12972">
                                          -{formatMoney(tx.commissionAmount)}
                                        </div>
                                      </div>
                                      <div className="hidden sm:flex items-center text-slate-300" data-id="element-12973">
                                        =
                                      </div>
                                      <div data-id="element-12974">
                                        <div className="text-xs text-slate-500 mb-1" data-id="element-12975">
                                          Вы получаете на руки
                                        </div>
                                        <div className="font-bold text-emerald-600 text-lg" data-id="element-12976">
                                          {formatMoney(tx.netAmount)}
                                        </div>
                                      </div>
                                    </div>
                                  </div>}
                            </div>
                          </td>
                        </tr>}
                    </Fragment>;
            }) : <tr data-id="element-12977">
                  <td colSpan={6} className="px-6 py-12 text-center text-slate-500" data-id="element-12978">
                    <FileText className="w-12 h-12 text-slate-300 mx-auto mb-3" data-id="element-12979" />
                    <div className="text-lg font-medium text-slate-900 mb-1" data-id="element-12980">
                      Транзакции не найдены
                    </div>
                    <p data-id="element-12981">Попробуйте изменить параметры фильтрации или поиска</p>
                  </td>
                </tr>}
            </tbody>
          </table>
        </div>

        {/* Mobile List */}
        <div className="md:hidden divide-y divide-slate-100" data-id="element-12982">
          {filteredTransactions.length > 0 ? filteredTransactions.map(tx => {
          const isExpanded = expandedTxId === tx.id;
          const config = getTypeConfig(tx.type);
          return <div key={tx.id} className="flex flex-col" data-id="element-12983">
                  {/* Mobile Card Header */}
                  <div className={`p-4 flex flex-col gap-3 cursor-pointer ${isExpanded ? 'bg-slate-50' : 'bg-white'}`} onClick={() => setExpandedTxId(isExpanded ? null : tx.id)} data-id="element-12984">
                    <div className="flex justify-between items-start" data-id="element-12985">
                      <div className="flex items-center gap-2" data-id="element-12986">
                        <div className={`p-1.5 rounded-md ${config.bg} ${config.color}`} data-id="element-12987">
                          {config.icon}
                        </div>
                        <div data-id="element-12988">
                          <div className="font-bold text-slate-900 text-sm" data-id="element-12989">
                            {tx.description}
                          </div>
                          <div className="text-xs text-slate-500 mt-0.5" data-id="element-12990">
                            {formatDate(tx.date)}
                          </div>
                        </div>
                      </div>
                      <div className="text-right" data-id="element-12991">
                        <div className={`font-bold ${tx.amount > 0 ? 'text-emerald-600' : 'text-slate-900'}`} data-id="element-12992">
                          {tx.amount > 0 ? '+' : ''}
                          {formatMoney(tx.amount)}
                        </div>
                        <div className="mt-1" data-id="element-12993">{getStatusBadge(tx.status)}</div>
                      </div>
                    </div>
                  </div>

                  {/* Mobile Expanded Details */}
                  {isExpanded && <div className="p-4 bg-slate-50 border-t border-slate-100 animate-in fade-in slide-in-from-top-2" data-id="element-12994">
                      <div className="space-y-3" data-id="element-12995">
                        <div className="flex justify-between text-sm" data-id="element-12996">
                          <span className="text-slate-500" data-id="element-12997">ID Транзакции</span>
                          <span className="font-mono text-slate-900" data-id="element-12998">
                            {tx.id}
                          </span>
                        </div>

                        {tx.orderId && <div className="flex justify-between text-sm" data-id="element-12999">
                            <span className="text-slate-500" data-id="element-13000">Заказ</span>
                            <span className="font-medium text-indigo-600" onClick={e => {
                    e.stopPropagation();
                    if (setActiveTab) setActiveTab('orders');else showToast(`Заказ ${tx.orderId}`);
                  }} data-id="element-13001">
                              {tx.orderId}
                            </span>
                          </div>}

                        {tx.clientName && <div className="flex justify-between text-sm" data-id="element-13002">
                            <span className="text-slate-500" data-id="element-13003">Клиент</span>
                            <span className="font-medium text-slate-900" data-id="element-13004">
                              {tx.clientName}
                            </span>
                          </div>}

                        {/* Commission Breakdown for Mobile */}
                        {tx.type === 'income' && tx.commissionAmount !== undefined && tx.netAmount !== undefined && <div className="mt-4 pt-4 border-t border-slate-200 space-y-2" data-id="element-13005">
                              <div className="text-xs font-bold text-slate-500 uppercase mb-2" data-id="element-13006">
                                Расчет выплаты
                              </div>
                              <div className="flex justify-between text-sm" data-id="element-13007">
                                <span className="text-slate-600" data-id="element-13008">
                                  Сумма заказа
                                </span>
                                <span className="font-medium text-slate-900" data-id="element-13009">
                                  {formatMoney(tx.amount)}
                                </span>
                              </div>
                              <div className="flex justify-between text-sm" data-id="element-13010">
                                <span className="text-slate-600" data-id="element-13011">
                                  Комиссия ({tx.commissionPercent}%)
                                </span>
                                <span className="font-medium text-rose-600" data-id="element-13012">
                                  -{formatMoney(tx.commissionAmount)}
                                </span>
                              </div>
                              <div className="flex justify-between text-base pt-2 border-t border-slate-200 mt-2" data-id="element-13013">
                                <span className="font-bold text-slate-900" data-id="element-13014">
                                  На руки
                                </span>
                                <span className="font-bold text-emerald-600" data-id="element-13015">
                                  {formatMoney(tx.netAmount)}
                                </span>
                              </div>
                            </div>}
                      </div>
                    </div>}
                </div>;
        }) : <div className="p-8 text-center text-slate-500" data-id="element-13016">
              <FileText className="w-10 h-10 text-slate-300 mx-auto mb-3" data-id="element-13017" />
              <div className="text-base font-medium text-slate-900 mb-1" data-id="element-13018">
                Транзакции не найдены
              </div>
            </div>}
        </div>
      </Card>

      {/* Withdraw Modal */}
      {showWithdrawModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/50 backdrop-blur-sm animate-in fade-in duration-200" data-id="element-13019">
          <div className="bg-white rounded-2xl shadow-xl w-full max-w-md overflow-hidden animate-in zoom-in-95 duration-200" data-id="element-13020">
            <div className="flex justify-between items-center p-5 border-b border-slate-100" data-id="element-13021">
              <h3 className="text-xl font-bold text-slate-900" data-id="element-13022">
                Вывод средств
              </h3>
              <button onClick={() => setShowWithdrawModal(false)} className="text-slate-400 hover:text-slate-600" data-id="element-13023">
                <X className="w-5 h-5" data-id="element-13024" />
              </button>
            </div>

            <div className="p-5 space-y-5" data-id="element-13025">
              {/* Amount Input */}
              <div data-id="element-13026">
                <label className="block text-sm font-bold text-slate-700 mb-2" data-id="element-13027">
                  Сумма вывода
                </label>
                <div className="relative" data-id="element-13028">
                  <input type="text" className="w-full pl-4 pr-12 py-3 text-2xl font-bold text-slate-900 bg-slate-50 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500" placeholder="0" value={withdrawAmount} onChange={e => {
                const val = e.target.value.replace(/\D/g, '');
                setWithdrawAmount(val ? new Intl.NumberFormat('ru-RU').format(parseInt(val)) : '');
              }} data-id="element-13029" />
                  <span className="absolute right-4 top-1/2 -translate-y-1/2 text-xl font-bold text-slate-400" data-id="element-13030">
                    ₽
                  </span>
                </div>
                <div className="flex justify-between mt-2 text-sm" data-id="element-13031">
                  <span className="text-slate-500" data-id="element-13032">
                    Доступно:{' '}
                    <span className="font-bold text-slate-900" data-id="element-13033">
                      {formatMoney(availableToWithdraw)}
                    </span>
                  </span>
                  <button className="text-indigo-600 font-medium hover:underline" onClick={() => setWithdrawAmount(new Intl.NumberFormat('ru-RU').format(availableToWithdraw))} data-id="element-13034">
                    Вывести всё
                  </button>
                </div>
              </div>

              {/* Method Selector */}
              <div data-id="element-13035">
                <label className="block text-sm font-bold text-slate-700 mb-2" data-id="element-13036">
                  Куда перевести
                </label>
                <div className="space-y-2" data-id="element-13037">
                  {methods.map(method => <label key={method.id} className={`flex items-center justify-between p-3 rounded-xl border cursor-pointer transition-all ${selectedMethodId === method.id ? 'border-indigo-500 bg-indigo-50/30 ring-1 ring-indigo-500' : 'border-slate-200 hover:border-indigo-300'}`} data-id="element-13038">
                      <div className="flex items-center gap-3" data-id="element-13039">
                        <input type="radio" name="withdrawMethod" className="w-4 h-4 text-indigo-600 border-slate-300 focus:ring-indigo-500" checked={selectedMethodId === method.id} onChange={() => setSelectedMethodId(method.id)} data-id="element-13040" />
                        <div data-id="element-13041">
                          <div className="font-bold text-slate-900 text-sm" data-id="element-13042">
                            {method.details}
                          </div>
                          <div className="text-xs text-slate-500" data-id="element-13043">
                            {method.name}
                          </div>
                        </div>
                      </div>
                      <CreditCard className="w-5 h-5 text-slate-400" data-id="element-13044" />
                    </label>)}
                </div>
              </div>

              {/* Summary */}
              <div className="bg-slate-50 rounded-xl p-4 border border-slate-100 space-y-3" data-id="element-13045">
                <div className="flex justify-between text-sm" data-id="element-13046">
                  <span className="text-slate-500" data-id="element-13047">Комиссия за вывод</span>
                  <span className="font-medium text-slate-900" data-id="element-13048">0 ₽ (0%)</span>
                </div>
                <div className="flex justify-between text-sm" data-id="element-13049">
                  <span className="text-slate-500" data-id="element-13050">Срок зачисления</span>
                  <span className="font-medium text-slate-900" data-id="element-13051">
                    1-3 рабочих дня
                  </span>
                </div>
                <div className="pt-3 border-t border-slate-200 flex justify-between items-center" data-id="element-13052">
                  <span className="font-bold text-slate-900" data-id="element-13053">
                    Итого к получению
                  </span>
                  <span className="text-xl font-bold text-emerald-600" data-id="element-13054">
                    {withdrawAmount ? formatMoney(parseInt(withdrawAmount.replace(/\D/g, ''))) : '0 ₽'}
                  </span>
                </div>
              </div>

              <Button variant="primary" size="lg" fullWidth onClick={handleWithdraw} data-id="element-13055">
                Подтвердить вывод
              </Button>
            </div>
          </div>
        </div>}

      {/* Download Modal */}
      {showDownloadModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/50 backdrop-blur-sm animate-in fade-in duration-200" data-id="element-13056">
          <div className="bg-white rounded-2xl shadow-xl w-full max-w-sm overflow-hidden animate-in zoom-in-95 duration-200" data-id="element-13057">
            <div className="flex justify-between items-center p-5 border-b border-slate-100" data-id="element-13058">
              <h3 className="text-lg font-bold text-slate-900" data-id="element-13059">
                Скачать выписку
              </h3>
              <button onClick={() => setShowDownloadModal(false)} className="text-slate-400 hover:text-slate-600" data-id="element-13060">
                <X className="w-5 h-5" data-id="element-13061" />
              </button>
            </div>

            <div className="p-5 space-y-4" data-id="element-13062">
              <div data-id="element-13063">
                <label className="block text-sm font-bold text-slate-700 mb-2" data-id="element-13064">
                  Период
                </label>
                <select className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500" value={downloadPeriod} onChange={e => setDownloadPeriod(e.target.value)} data-id="element-13065">
                  <option value="week" data-id="element-13066">За неделю</option>
                  <option value="month" data-id="element-13067">За месяц</option>
                  <option value="quarter" data-id="element-13068">За квартал</option>
                  <option value="year" data-id="element-13069">За год</option>
                  <option value="all" data-id="element-13070">За всё время</option>
                </select>
              </div>

              <div data-id="element-13071">
                <label className="block text-sm font-bold text-slate-700 mb-2" data-id="element-13072">
                  Тип операций
                </label>
                <select className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500" value={downloadType} onChange={e => setDownloadType(e.target.value)} data-id="element-13073">
                  <option value="all" data-id="element-13074">Все операции</option>
                  <option value="income" data-id="element-13075">Только доходы</option>
                  <option value="withdrawal" data-id="element-13076">Только выводы</option>
                </select>
              </div>

              <div className="pt-2" data-id="element-13077">
                <Button variant="primary" fullWidth icon={<Download className="w-4 h-4" data-id="element-13079" />} onClick={handleDownload} data-id="element-13078">
                  Скачать CSV
                </Button>
              </div>
            </div>
          </div>
        </div>}
    </div>;
}